import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "#F4F4F5",
      rx: "6"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#F63D68",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m14 7-5.5 5.5L6 10"
    }, null, -1)
  ])))
}
export default { render: render }